var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('GlobalNotice',{on:{"notice-closed":_vm.handleNoticeClosed}}),_c('Navbar',{class:{ 'navbar-with-notice': _vm.showNotice }}),_c('div',{staticClass:"app-view"},[_c('router-view')],1),_c('FloatingControls'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }